var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNet = function SvgNet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.625 15.375v-6m12.75 6v-6m0-3.375V2.625H9M15.375 6H2.625m12.75 0v3.375M2.625 6V2.625H6M2.625 6v3.375m12.75 0H9m-6.375 0H6m0-6.75v6.75m0-6.75h3m-3 6.75h3m0-6.75v6.75m3-6.75v6"
  })));
};
export default SvgNet;